// extracted by mini-css-extract-plugin
module.exports = {"pageName":"StockTransfers_pageName__3UZtk"};